const CandidateFeedbackIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        d="M14 3C14.7652 2.99996 15.5015 3.29233 16.0583 3.81728C16.615 4.34224 16.9501 5.06011 16.995 5.824L17 6V10H13L12.824 10.005C12.0904 10.0481 11.3981 10.3589 10.8785 10.8785C10.3589 11.3981 10.0481 12.0904 10.005 12.824L10 13V17H6C5.23479 17 4.49849 16.7077 3.94174 16.1827C3.38499 15.6578 3.04989 14.9399 3.005 14.176L3 14V6C2.99996 5.23479 3.29233 4.49849 3.81728 3.94174C4.34224 3.38499 5.06011 3.04989 5.824 3.005L6 3H14ZM16.9 11.001C16.8225 11.2388 16.7011 11.46 16.542 11.653L16.414 11.793L11.793 16.414C11.569 16.638 11.297 16.804 11.001 16.901L11 13L11.005 12.85C11.0408 12.3738 11.2458 11.9262 11.5829 11.588C11.92 11.2498 12.3669 11.0433 12.843 11.006L13 11L16.9 11.001Z"
        fill="#942020"
      />
    </svg>
  );
};

export default CandidateFeedbackIcon;
